import React from 'react';
import { Button } from './ui/button';
export function FinalCTA() {
  return <section className="relative py-24 md:py-32 flex items-center justify-center overflow-hidden" data-id="element-79">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1613490908578-15c1238a0739?q=80&w=2070&auto=format&fit=crop")'
    }} data-id="element-80" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-charcoal/90 z-10" data-id="element-81" />

      <div className="container mx-auto px-4 md:px-6 relative z-20 text-center max-w-[800px]" data-id="element-82">
        <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-6" data-id="element-83">
          Ready to list for 1%?
        </p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-84">
          Keep more of your equity. Without cutting corners.
        </h2>
        <p className="text-white/70 text-lg md:text-xl mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-85">
          Free, no-obligation consultation. We walk through your home's value,
          your timeline, and a pricing strategy built to win.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-86">
          <Button className="bg-brick-red hover:bg-brick-red-dark text-white h-14 px-10 text-lg w-full sm:w-auto" data-id="element-87">
            Book a Free Consultation
          </Button>
          <Button variant="outline" className="border-white text-white hover:bg-white hover:text-charcoal bg-transparent h-14 px-10 text-lg w-full sm:w-auto" data-id="element-88">
            Call (480) 256-2262
          </Button>
        </div>
      </div>
    </section>;
}